import React from "react"
import RevolutionSlider from "../components/HomeComponents/RevolutionSlider"
import SearchRoom from "../components/HomeComponents/SearchRoom"
import Welcome from "../components/HomeComponents/Welcome"
import VideoArea from "../components/HomeComponents/VideoArea"
import Welcome2 from "../components/HomeComponents/Welcome2"
import ServicesArea from "../components/HomeComponents/ServicesArea"
import Discount from "../components/HomeComponents/Discount"
import Testimonials from "../components/HomeComponents/Testimonials"
import Layout from "../components/Layout"

const Home = () => (
    <Layout>
        <div id="main-content" className="main-content">
            <div id="home-main-content" className="home-main-content home-1">
                <RevolutionSlider />
                <SearchRoom />
                <div className="empty-space"></div>
                <Welcome />
                <div className="empty-space"></div>
                <VideoArea />
                <div className="empty-space"></div>
                <Welcome2 />
                <div className="empty-space"></div>
                <Discount />
                <ServicesArea />
                <Testimonials />
            </div>
        </div>
    </Layout>
)

export default Home